<template>
  <div
    class="calc-radio-btn"
    :class="{ 'active': active }"
  >
    <svg
      v-if="active"
      class="calc-radio-btn__icon"
      width="24px"
      height="24px"
    >
      <use xlink:href="#select-on" />
    </svg>
    <svg
      v-else
      class="calc-radio-btn__icon"
      width="24px"
      height="24px"
    >
      <use xlink:href="#select-off" />
    </svg>
    <div class="calc-package-item__left">
      <div class="calc-package-item__desc">
        <div class="calc-radio-btn__name">
          {{ name }}
        </div>
        <div class="calc-radio-btn__size">
          {{ size }}
        </div>
      </div>
      <div class="calc-radio-btn__desc">
        <span v-if="!isMobile">В эту упаковку поместится:</span>
        <br v-if="!isMobile">
        {{ desc }}
      </div>
    </div>
    <img
      v-if="isMobile || isTablet"
      :src="'https://storage.yandexcloud.net/boxberrysite-public/calculator_pip/' + imgName +'.svg'"
      width="89"
      height="88"
      alt="package"
      loading="lazy"
    >
  </div>
</template>

<script>
import deviceInfo from '../../../helpers/device';

export default {
  name: 'CalcPackageItem',
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: true,
    },
    desc: {
      type: String,
      required: true,
    },
    packageId: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    imgName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...deviceInfo,
  }
};
</script>

<style lang="scss" scoped>
.calc-package-item {

}
.calc-package-item__left {
  margin-right: 8px;
}
.calc-package-item__desc {
  @media (min-width: 1051px) {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 6px;
  }
}
.calc-radio-btn__name {
  @media (min-width: 1051px) {
    margin-right: 8px;
    margin-bottom: 0 !important;
  }
}
.calc-radio-btn {
  @media (min-width: 1051px) {
    padding-right: 15px !important;
    padding-left: 47px !important;
  }
}
.calc-radio-btn__size {
  @media (min-width: 1051px) {
    margin-bottom: 0 !important;
  }
}
.calc-radio-btn {
  .calc-radio-btn__icon {
    @media (max-width: 1050px) {
      top: 28px;
    }
  }
  .calc-radio-btn__desc {
    span {
      font-style: italic;
      font-weight: 400;
    }
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    color: #50616F;
    font-style: normal;
    @media (max-width: 1050px) {
      font-style: italic;
      font-weight: 400;
    }
  }
}


</style>
